export default {
  getArticles(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/blog/articles?${queryString}`)
        .then(response => {
          context.commit("setArticles", response.data.results);
          context.commit("setPagination", {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
            current: response.data.results.length
          });
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },
  getArticle(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/blog/articles/${id}`)
        .then(response => {
          context.commit("setArticle", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getCategories(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/blog/categories?${queryString}`)
        .then(response => {
          context.commit("setCategories", response.data.results);
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },
  getLocations(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/blog/locations`)
        .then(response => {
          context.commit("setLocations", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getSubjects(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/blog/subjects`)
        .then(response => {
          context.commit("setSubjects", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getLevels(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/blog/levels`)
        .then(response => {
          context.commit("setLevels", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  }
};
